<div id="betting__container"></div>
<div id="betting-betslip" class="footer-fixed" [ngClass]="className"></div>